import {
    DriveFileMoveRounded,
    PlayCircle,
    ArrowBack,
    Settings,
    CheckCircle,
    DoneAll,
    FileDownloadOutlined,
    FileUploadOutlined,
    Mail,
    Send,
} from "@mui/icons-material";
import { Box, Button, Card, CardContent, Grid } from "@mui/material";
import { GridRowModel, GridRowSelectionModel, GridSortModel, GridSortDirection } from "@mui/x-data-grid";
import React, { useEffect, useMemo, useState } from "react";

import { Container } from "@/theme/globalStyles";
import DataTable from "../../../components/dataTable";
import serviceRebalance from "@/services/serviceRebalanceUsinaInstalacao";
import { useAuth } from "../../../context/global";
import { useHistory } from "react-router-dom";
import Actions from "../utils/actions";
import { format } from "date-fns";

const RebalanceDetalhar: React.FC = (props: any) => {
    const { setTitlePage } = useAuth();
    const history = useHistory();
    const filterOld = props.location.state.filterOld || "";

    useEffect(() => {
        setTitlePage("Detalhar");
    }, [setTitlePage]);

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [linesSelecteds, setLinesSelecteds] = useState<GridRowSelectionModel>([]);

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
          field: "",
          sort: "" as GridSortDirection
        }
      ]);

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "rebalanceUsinaInstalacaoID",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 70,
            },
            {
                headerName: "UC",
                field: "numeroInstalacao",
                type: "string",
                width: 180,
            },
            {
                headerName: "Nome",
                field: "nomeCliente",
                type: "string",
                width: 260,
            },
            {
                headerName: "Cod. Cliente",
                field: "codigoCliente",
                type: "string",
                width: 190,
            },
            {
                headerName: "Classe",
                field: "classeInstalacao",
                type: "string",
                width: 100,
            },
            {
                headerName: "Disp",
                field: "disponibilidade",
                type: "string",
                width: 100,
            },
            {
                headerName: "Usina",
                field: "nomeUsina",
                type: "string",
                width: 190,
            },
            {
                headerName: "Mês de Ref.",
                field: "mesReferencia",
                type: "string",
                width: 100,
            },
            {
                headerName: "Inj. Prevista",
                field: "injecaoPrevista",
                type: "number",
                width: 120,
            },
            {
                headerName: "Inj. Realizada",
                field: "injecaoRealizada",
                type: "number",
                width: 120,
            },
            {
                headerName: "Saldo Cons. Anterior",
                field: "saldoConsolidadoAnterior",
                type: "number",
                width: 180,
            },
            {
                headerName: "Saldo Cons. Atual",
                field: "saldoConsolidadoAtual",
                type: "number",
                width: 180,
            },
            {
                headerName: "Saldo não pago anterior",
                field: "saldoAlsolAnterior",
                type: "number",
                width: 180,
            },
            {
                headerName: "Saldo não pago atual",
                field: "saldoAlsolAtual",
                type: "number",
                width: 180,
            },
            {
                headerName: "Saldo Conc. Anterior",
                field: "saldoConcessionariaAnterior",
                type: "number",
                width: 180,
            },
            {
                headerName: "Saldo Conc. Atual",
                field: "saldoConcessionariaAtual",
                type: "number",
                width: 180,
            },

            {
                headerName: "Saldo outros anterior",
                field: "saldoOutrosAnterior",
                type: "number",
                width: 190,
            },
            {
                headerName: "Saldo outros atual",
                field: "saldoOutrosAtual",
                type: "number",
                width: 190,
            },
            {
                headerName: "Parceiro",
                field: "nomeParceiro",
                type: "string",
                width: 140,
            },

            {
                headerName: "Cota contrat.",
                field: "cotaContratada",
                type: "number",
                width: 150,
            },
            {
                headerName: "% mínimo cota",
                field: "percentualMinimoCota",
                type: "number",
                width: 150,
            },
            {
                headerName: "% máximo cota",
                field: "percentualMaximoCota",
                type: "number",
                width: 150,
            },
            {
                headerName: "Ajuste Manual",
                field: "ajusteManual",
                type: "number",
                width: 150,
            },
            {
                headerName: "injeção fixa",
                field: "injecaoFixa",
                type: "number",
                width: 150,
            },
            {
                headerName: "Tipo injeção Fixa calc.",
                field: "tipoInjecaoFixaCalculada",
                type: "string",
                width: 190,
            },
            {
                headerName: "Status Fatura Prev.",
                field: "statusFaturaPrevista",
                type: "string",
                width: 150,
            },
            {
                headerName: "Média consumo",
                field: "mediaConsumo",
                type: "number",
                width: 190,
            },
            {
                headerName: "Cota kWh",
                field: "cotaKwh",
                type: "number",
                width: 150,
            },
            {
                headerName: "Perc. saldo sobre cota",
                field: "percentualSaldoSobreCota",
                type: "number",
                width: 190,
            },
            {
                headerName: "Perc. media cons. sobre cota",
                field: "percentualMediaConsumoSobreCota",
                type: "number",
                width: 190,
            },
            {
                headerName: "Prev. Consumo M1",
                field: "previsaoConsumoM1",
                type: "number",
                width: 150,
            },
            {
                headerName: "Prev. Consumo M2",
                field: "previsaoConsumoM2",
                type: "number",
                width: 150,
            },
            {
                headerName: "Saldo Rebalance Atual",
                field: "saldoRebalanceAtual",
                type: "number",
                width: 150,
            },
            {
                headerName: "Cota kWh calculada",
                field: "cotaKwhCalculada",
                type: "number",
                width: 150,
            },
            {
                headerName: "Cota 50% Disp.",
                field: "cota50Disponibilidade",
                type: "number",
                width: 150,
            },
            {
                headerName: "Prev Consumo",
                field: "previsaoConsumo",
                type: "number",
                width: 150,
            },
            {
                headerName: "Prev Con. Disp.",
                field: "previsaoConsumoDisponibilidade",
                type: "number",
                width: 150,
            },
            {
                headerName: "Saldo 50% cota",
                field: "saldo50Cota",
                type: "number",
                width: 150,
            },
            {
                headerName: "Saldo 50% cons",
                field: "saldo50Consumo",
                type: "number",
                width: 150,
            },
            {
                headerName: "Redução",
                field: "reducao",
                type: "number",
                width: 150,
            },
            {
                headerName: "Acréscimo",
                field: "acrescimo",
                type: "number",
                width: 150,
            },
            {
                headerName: "Injeção",
                field: "injecao",
                type: "number",
                width: 150,
            },
            {
                headerName: "Injeção trava",
                field: "injecaoTrava",
                type: "number",
                width: 150,
            },
            {
                headerName: "Trava",
                field: "trava",
                type: "string",
                width: 70,
            },
            {
                headerName: "Ajuste",
                field: "ajuste",
                type: "number",
                width: 100,
            },
            {
                headerName: "Nova cota",
                field: "novaCota",
                type: "number",
                width: 100,
            },
            {
                headerName: "Per. Dist. Ajustada",
                field: "percentualDistribuidoraAjustado",
                type: "number",
                width: 150,
            },
            {
                headerName: "Dif. Previsão Saldo",
                field: "diferencaPrevisaoSaldo",
                type: "number",
                width: 150,
            },

            {
                headerName: "Dif. Saldo",
                field: "diferencaSaldo",
                type: "number",
                width: 150,
            },
            {
                headerName: "Dif. Percentual",
                field: "diferencaPercentual",
                type: "number",
                width: 150,
            },
            {
                headerName: "Dif. Cota",
                field: "diferencaCota",
                type: "number",
                width: 150,
            },

            {
                headerName: "Perf. saldo atual",
                field: "percentualSaldoAtual",
                type: "number",
                width: 190,
            },
            {
                headerName: "Perf. diferença cota",
                field: "percentualDiferencaCota",
                type: "number",
                width: 190,
            },
            {
                headerName: "Perf. diferença cota e saldo",
                field: "percentualDiferencaCotaSaldo",
                type: "number",
                width: 190,
            },
        ],
        []
    );

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        serviceRebalance
            .getWithFilter({
                ...filters,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                if (result) {
                    setData(result?.data.content);
                    setRowCount(result?.data.numberOfElements);
                }
            })
            .catch((err) => {
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            getAllWithFilters(filters);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    useEffect(() => {
        if (props && props.location && props.location.state) {
            setFilters(props.location.state);
            getAllWithFilters(props.location.state);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item md={12}>
                                <Grid container spacing={2}>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="text"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<ArrowBack />}
                                            onClick={() => {
                                                const newArray = filterOld.usinasIds
                                                    ? Array.isArray(filterOld.usinasIds)
                                                        ? filterOld.usinasIds
                                                        : filterOld.usinasIds.split(",")
                                                    : "";

                                                history.push("/rebalance/historicoProcessamento", {
                                                    ...filterOld,
                                                    usinasIds: newArray,
                                                });
                                            }}
                                        >
                                            Voltar
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<FileDownloadOutlined />}
                                            onClick={() => { 
                                                const usinaId = props.location.state.usinaID.toString();
                                                const ciclo = props.location.state.filterOld.cicloFaturamento ? format(props.location.state.filterOld.cicloFaturamento, "MM/yyyy") : format(new Date(), "MM/yyyy");
                                                Actions.serviceDownload(usinaId, ciclo )
                                            }}
                                            disabled={
                                            props.location.state.usinaID &&
                                            props.location.state.status !== "Aberto" &&
                                            props.location.state.status !== "Erro" &&
                                            props.location.state.status !== "Processado"}
                                        >
                                            Download
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<FileUploadOutlined />}
                                            onClick={() => {}}
                                            disabled={true}
                                        >
                                            Importar
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<PlayCircle />}
                                            onClick={() => {
                                                Actions.serviceStart(props.location.state.usinaID.toString(), props.location.state.filterOld.cicloFaturamento);

                                            }}
                                            disabled={props.location.state.usinaID && props.location.state.status !== "A iniciar" && props.location.state.status !== "Sem Movimento"}
                                        >
                                            Iniciar
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<Settings />}
                                            onClick={() => {
                                                Actions.serviceProcess(props.location.state.usinaID.toString(), props.location.state.filterOld.cicloFaturamento);

                                            }}
                                            disabled={
                                            props.location.state.usinaID &&
                                            props.location.state.status !== "Aberto" &&
                                            props.location.state.status !== "Erro" &&
                                            props.location.state.status !== "Processado"}
                                        >
                                            processar
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<DriveFileMoveRounded />}
                                            onClick={() => alert("cliquei")}
                                            disabled={true}
                                        >
                                            Reabrir
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item md={12}>
                                <Grid container spacing={2}>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<CheckCircle />}
                                            onClick={() => alert("cliquei")}
                                            disabled={true}
                                        >
                                            Aprovar
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<Mail />}
                                            onClick={() => alert("cliquei")}
                                            disabled={true}
                                        >
                                            Enviar Con.
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<DoneAll />}
                                            onClick={() => alert("cliquei")}
                                            disabled={true}
                                        >
                                            Gerar Revisão
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<Send />}
                                            onClick={() => alert("cliquei")}
                                            disabled={true}
                                        >
                                            Sankya
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.rebalanceUsinaInstalacaoID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            checkboxSelection
                            onRowSelectionModelChange={(newSelectionModel) => {
                                setLinesSelecteds(newSelectionModel);
                            }}
                            rowSelectionModel={linesSelecteds}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>
                </CardContent>
            </Card>
        </Container>
    );
};

export default RebalanceDetalhar;
